import SelectFilterModal from './SelectFilterModal'
import useUzytkownikFilterModal from '../hooks/useUzytkownikFilterModal'

export default function UzytkownikFilterModal({
	isOpen,
	onClose,
	selectedUzytkownikId,
	onApply,
	title = 'Filtruj po uzytkowniku',
	description = 'Wybierz uzytkownika, aby zawezic liste kampanii.',
	applyLabel = 'Zastosuj',
	clearLabel = 'Wyczysc filtr',
}) {
	const state = useUzytkownikFilterModal(isOpen, selectedUzytkownikId)
	return (
		<SelectFilterModal
			isOpen={isOpen}
			onClose={onClose}
			onApply={onApply}
			title={title}
			description={description}
			placeholder="Szukaj uzytkownika po nazwie..."
			emptyMessage="Nie znaleziono uzytkownikow"
			applyLabel={applyLabel}
			clearLabel={clearLabel}
			{...state}
		/>
	)
}
